export const EXCEL_TYPE =
  'application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const JPEG_TYPE = 'image/jpeg';
export const PNG_TYPE = 'image/png';
export const PDF_TYPE = 'application/pdf';
export const SVG_TYPE = 'image/svg+xml';
export const IMAGE = 'Image';
export const DOCS_TYPE =
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
export const PPTX_TYPE =
  'application/vnd.openxmlformats-officedocument.presentationml.presentation';
export const TEXT_TYPE = 'text/plain';
export const CSV_TYPE = 'text/csv';

export const ATTACHMENT_FILE_TYPES = `${JPEG_TYPE}, ${PNG_TYPE}, ${PDF_TYPE}, ${SVG_TYPE}, ${EXCEL_TYPE}, ${DOCS_TYPE}, ${PPTX_TYPE}, ${TEXT_TYPE}, ${CSV_TYPE}`;

export const ATTACHMENT_FILE_SIZE = 20 * 1024 * 1024;
